/**
 * Multi-empresa (frontend compartido).
 *
 * useMultiempresa() consulta /api/multiempresa_estado (accesible a cualquier
 * usuario autenticado) y devuelve { activo, empresas }. Con el modo apagado
 * los reportes no muestran nada nuevo. SelectorEmpresa es el dropdown
 * estándar "Todas / 1 / 2" para filtros de reportes.
 */
import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { useApi } from "lib/api";

export function useMultiempresa() {
  const { post } = useApi();
  const [estado, setEstado] = useState({ activo: false, empresas: [] });
  useEffect(() => {
    let vivo = true;
    post("/api/multiempresa_estado", {})
      .then(({ ok, data }) => {
        if (vivo && ok) {
          setEstado({ activo: !!data.activo, empresas: data.empresas || [] });
        }
      })
      .catch(() => {});
    return () => {
      vivo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return estado;
}

/**
 * Logo de una empresa (data URL) para encabezados de reportes PDF.
 * `empresa` en 0/""/null pide el de la empresa principal (el backend cae a
 * ella también cuando la pedida no tiene logo). Devuelve "" mientras carga o
 * si el tenant no tiene logo: los reportes imprimen sin él, como siempre.
 */
export function useLogoEmpresa(empresa) {
  const { post } = useApi();
  const [logo, setLogo] = useState("");
  useEffect(() => {
    let vivo = true;
    const num = Number(empresa);
    post("/api/empresa_logo", num > 0 ? { empresa: num } : {})
      .then(({ ok, data }) => {
        if (vivo) setLogo(ok ? data.logo || "" : "");
      })
      .catch(() => {});
    return () => {
      vivo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresa]);
  return logo;
}

export function nombreEmpresa(empresas, numero) {
  const e = (empresas || []).find((x) => String(x.empresa) === String(numero));
  return e ? e.nombre || `Empresa ${numero}` : `Empresa ${numero}`;
}

/** Selector de empresa para filtros de reportes (0 = Todas). */
export function SelectorEmpresa({ value, onChange, empresas, conTodas = true, sx, size }) {
  return (
    <TextField
      select
      fullWidth
      size={size}
      label="Empresa"
      value={String(value ?? "0")}
      onChange={(e) => onChange(e.target.value)}
      sx={sx}
    >
      {conTodas && <MenuItem value="0">Todas</MenuItem>}
      {(empresas || []).map((e) => (
        <MenuItem key={e.empresa} value={String(e.empresa)}>
          {e.empresa} — {e.nombre || `Empresa ${e.empresa}`}
        </MenuItem>
      ))}
    </TextField>
  );
}
